import { bulkIdRegisterReducerKey } from './BulkIdRegisterConstants';

export function bulkIdRegister(state) {
  return state.get(bulkIdRegisterReducerKey);
}

export function ipAddress(state) {
  return bulkIdRegister(state).get('ipAddress');
}

export function data(state) {
  return bulkIdRegister(state).get('data');
}

export function isLoading(state) {
  return bulkIdRegister(state).get('isLoading');
}

export function loginFail(state) {
  return bulkIdRegister(state).get('loginFail');
}
